<div class="container-fluid text-center">
    <form class="form-signin">
      <img routerLink="/" class="mb-4" src="https://cdn.iconscout.com/icon/free/png-512/koala-bear-lazy-honey-wild-animal-33903.png" width="60" height="60" alt="">
      <h1 class="h3 mb-3 font-weight-normal">Reset Password</h1>
      <p> Enter your email address below and we'll send you a link to reset your password.</p>
      <label for="inputEmail" class="sr-only">Email address</label>
      <input type="email" id="inputEmail" class="form-control" placeholder="Email address" formControlName="email" required autofocus>
      <br>
      <button type="submit" routerLink="/" class="btn btn-outline-success my-2 my-sm-0" style="margin:auto"> Cancel </button>
      <button type="submit" class="btn btn-outline-success my-2 my-sm-0"> Reset Password</button>
  </form>
  </div>